// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    ICart,
    ICheckoutSessionStatusItem,
}                               from '../interfaces';

const updateCheckoutSessionItem = async ({
    test,
    paymentIntentId,
    statusesToAdd,
    cartsToAdd,
    promotionIdsToAdd,
    promotionIdsToRemove,
}: {
    test: boolean,
    paymentIntentId: string,
    statusesToAdd?: ICheckoutSessionStatusItem[],
    cartsToAdd?: ICart[],
    promotionIdsToAdd?: string[],
    promotionIdsToRemove?: string[],
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleUpdateCheckoutSessionItem = httpsCallable<
        Record<
            string,
            boolean | string | string[] | ICheckoutSessionStatusItem[] | ICart[] | undefined
        >,
        boolean
    >(
        functions,
        'updateCheckoutSessionItem',
    );
    return handleUpdateCheckoutSessionItem({
        test,
        paymentIntentId,
        statusesToAdd,
        cartsToAdd,
        promotionIdsToAdd,
        promotionIdsToRemove,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default updateCheckoutSessionItem;
